import { render, staticRenderFns } from "./BrandOfflineSelect.vue?vue&type=template&id=31b6f014&scoped=true&"
import script from "./BrandOfflineSelect.vue?vue&type=script&lang=js&"
export * from "./BrandOfflineSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6f014",
  null
  
)

export default component.exports